export default [
  {
    header: 'My Dashboard',
  },
  {
    title: 'Portfolio',
    route: 'home',
    icon: 'KeyIcon',
    tag: 'Soon',
    tagVariant: 'light-warning',
    disabled: true,
  },
]
